import { useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';

import ClearOutlinedIcon from '@mui/icons-material/ClearOutlined';
import TaskAltIcon from '@mui/icons-material/TaskAlt';


export default function LoadListListItemLinkComplete(props){
    //console.debug("RTS Break LoadListListItemLinkComplete");

    const history = useNavigate();

    function handleClick(e){
        history("/LoadListComplete", {state: {idGuid:props.idGuid}});
    };


    if(props.status === 1){
        return (
            <Link onClick={handleClick}  sx={{textDecoration:'none', cursor:'pointer'}}>
                <Box sx={{display:'flex'}}>
                    <TaskAltIcon />
                    <Typography sx={{fontWeight:'bold', pl:'2px'}}>Complete Reel Use</Typography>
                </Box>
            </Link>
        )
    }
    else{
        return (
            <Link onClick={handleClick} sx={{textDecoration:'none', cursor:'pointer'}}>
                <Box sx={{display:'flex'}}>
                    <TaskAltIcon sx={{color:"red"}} />
                    <ClearOutlinedIcon sx={{color:"red", verticalAlign:"super", fontSize:'.90em', ml:-1, fontWeight:'bold'}} />
                    <Typography color="red" sx={{fontWeight:'bold', pl:'2px'}}>Remove Completion </Typography>
                </Box>
            </Link>
        )
    }
}
